<script lang="ts" setup>
import type { ChallengeRank, Challenge, ChallengeType } from '~/types/challenge'

const mainStore = useMainStore()
const authStore = useAuthStore()

const props = defineProps<{
  rank: ChallengeRank
  challenge: Challenge
  highlightUser?: boolean
  scoreClasses?: string
  manualChallengeType?: ChallengeType
}>()

const isCurrentUser = computed(() => props.rank.user_id === authStore.currentUser?.id)
</script>

<template>
  <div
    class="tw-flex tw-flex-row tw-items-center tw-gap-3 tw-border-b tw-border-black/5 tw-py-2 last:tw-border-b-0"
  >
    <span class="tw-font-bold">{{ props.rank.rank }}</span>

    <NuxtLink :to="'/user/' + props.rank.user_id" :external="mainStore.isLoadedFromApp">
      <RelationshipUserImage
        :user="props.rank"
        class="tw-h-10 tw-w-10 tw-rounded-full tw-object-cover"
      />
    </NuxtLink>

    <NuxtLink
      :to="'/user/' + props.rank.user_id"
      class="tw-flex-shrink tw-flex-grow tw-truncate"
      :external="mainStore.isLoadedFromApp"
    >
      <span> {{ props.rank.firstname }} {{ props.rank.lastname }} </span>
    </NuxtLink>

    <div
      v-if="props.manualChallengeType || props.challenge.type"
      class="tw-flex-shrink-0 tw-whitespace-nowrap"
    >
      <ChallengeUnitRenderer
        :value-classes="scoreClasses"
        :unit-classes="scoreClasses"
        :challenge-type="props.manualChallengeType ?? props.challenge.type"
        :rank="props.rank"
      />
    </div>
  </div>
</template>
